import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2G1Item1 = {
    locationWhereShipLaidUp: string;
};

export type TBFL2G1Item2 = {
    contingencyActions: string;
};

export type TBFL2G1Item3 = {
    precautionsTaken: string;
};

export type TBFL2G1Item4 = {
    dateWhenShipReturnedToNormal: string;
};

export type TBFL2G1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2G1;
        item1: TBFL2G1Item1;
        item2: TBFL2G1Item2;
        item3: TBFL2G1Item3;
        item4: TBFL2G1Item4;
    };

export type TBFL2G = TBFL2G1;

const BFL2G_DEFAULTS: {
    G1: TBFL2G1;
} = {
    G1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            locationWhereShipLaidUp: '',
        },
        item2: {
            contingencyActions: '',
        },
        item3: {
            precautionsTaken: '',
        },
        item4: {
            dateWhenShipReturnedToNormal: '',
        },
        recordCode: EBFL2RecordCode.BFL2G1,
    },
};

export { BFL2G_DEFAULTS };
